import { useCallback, useEffect, useState } from 'react';
import { api } from '@/lib/api';

export function useFavorites() {
  const [favoriteIds, setFavoriteIds] = useState<Set<number>>(new Set());
  const [loaded, setLoaded] = useState(false);

  const refresh = useCallback(() => {
    api
      .get<{ placeIds: number[] }>('/favorites')
      .then((res) => setFavoriteIds(new Set(res.placeIds)))
      .finally(() => setLoaded(true));
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const toggle = useCallback(async (placeId: number) => {
    setFavoriteIds((prev) => {
      const next = new Set(prev);
      if (next.has(placeId)) next.delete(placeId);
      else next.add(placeId);
      return next;
    });
    try {
      if (favoriteIds.has(placeId)) {
        await api.del(`/favorites/${placeId}`);
      } else {
        await api.post(`/favorites/${placeId}`);
      }
    } catch {
      refresh();
    }
  }, [favoriteIds, refresh]);

  return { favoriteIds, isFavorite: (id: number) => favoriteIds.has(id), toggle, loaded };
}
